module.exports = __webpack_public_path__ + "assets/943da69125c791e5bbc40d9a522b9d26.mp3";